import { render, staticRenderFns } from "./referrer.vue?vue&type=template&id=1c9fd5cf&"
import script from "./referrer.vue?vue&type=script&lang=ts&"
export * from "./referrer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports